import { $i18n } from '../../y/i18n';
import { UILink, $el } from '../elements';
import { UIValue, UIClassesSpec } from '../types';
import { UIViewAddSpec } from '../view';
import { UIButton } from './button';
import { UIDialog, UIDialogOptions } from './dialog';
import { UITextInput } from './input';

export interface UIWarningOptions extends UIDialogOptions {
    content?: UIViewAddSpec;
    title?: string;
    text?: UIViewAddSpec;
    texts?: UIViewAddSpec[];
    cancel_text?: string | null;
    ok_text?: string | null;
    link_text?: string;
    link_link?: UILink;
    link_click?: () => void;
    buttons?: UIValue[];
    button_classes?: UIClassesSpec;
}

export class UIWarning extends UIDialog<string> {
    constructor(options: UIWarningOptions) {
        super(options);
        this.classList.add('m-flexible-460');

        const content = this.content;
        content.classList.add('w-block');
        const button_classes = options.button_classes ?? 'ui-tint-reverse';

        content.ui_add([
            options.content,
            options.title && $el.H2('title', options.title),
            options.text && $el.P('text', options.text),
            options.texts && $el.Ps('text', options.texts),
            $el.DIV('s-small'),
            $el.DIV('l-button-row', [
                options.link_text && [
                    new UIButton({
                        kind: 'k-text', title: options.link_text, link: options.link_link, classes: 'm-inline', on_click: options.link_click && (() => {
                            this.dismiss(null);
                            options.link_click!();
                        })
                    }),
                    $el.S(),
                ],
                options.cancel_text !== null && new UIButton({ title: options.cancel_text || $i18n.ui.button_cancel, classes: ['m-hollow', button_classes], on_click: () => { this.dismiss(null) } }),
                options.buttons?.map(b => new UIButton({ title: b.name, on_click: () => { this.dismiss(b.key as string) } })),
                options.ok_text !== null && new UIButton({ title: options.ok_text || $i18n.ui.button_ok, classes: button_classes, on_click: () => { this.dismiss('ok') } })
            ]),
        ]);
    }
}

interface UIInputDialogOptions extends UIDialogOptions {
    title?: UIViewAddSpec;
    text?: UIViewAddSpec;
    texts?: UIViewAddSpec[];
    cancel_text?: string;
    ok_text?: string;
    color?: string;
}

class UIInputDialog extends UIDialog<string> {
    constructor(options: UIInputDialogOptions) {
        super(options);
        this.classList.add('m-flexible-460');

        const content = this.content;
        content.classList.add('w-block');
        const input = new UITextInput({ autofocus: true });

        this.content.ui_add([
            options.title && $el.H2('title', options.title),
            options.text && $el.P('text', options.text),
            options.texts && $el.Ps('text', options.texts),
            input,
            $el.DIV('s-small'),
            $el.DIV('l-button-row', [
                new UIButton({ title: options.cancel_text || $i18n.ui.button_cancel, classes: 'm-hollow', on_click: () => { this.dismiss(null) } }),
                new UIButton({ title: options.ok_text || $i18n.ui.button_ok, on_click: () => { this.dismiss(input.value) } })
            ])
        ]);
    }
}

export function showWarning(options: UIWarningOptions) {
    return new UIWarning(options).present();
}

export function showInputDialog(options: UIInputDialogOptions) {
    return new UIInputDialog(options).present();
}
